const environment = JSON.parse(process.env.VUE_APP_RAS_ENV_MAPPING)[window.location.host] || 'develop';
const host = `${process.env.VUE_APP_RAS_HOST}/${environment}/api/v1`;
const PARALLEL_PROCESSSING_LIMIT = 10;
const queue = [];
let processing = 0;

async function execute() {
  if (processing >= PARALLEL_PROCESSSING_LIMIT || !queue.length) {
    return;
  }

  processing += 1;

  const { call, resolve, reject } = queue.shift();

  let retriesLeft = 3;

  let errObj;

  while (retriesLeft) {
    try {
      if (retriesLeft < 3) {
        console.info('retrying');
      }
      // eslint-disable-next-line no-await-in-loop
      const output = await call();
      resolve(output);
      processing -= 1;
      execute();
      return;
    } catch (err) {
      errObj = err;
    } finally {
      retriesLeft -= 1;
    }
  }

  reject(errObj);
  processing -= 1;
  execute();
}

export const saveResource = async (body, { request, resourceType }) => {
  return new Promise((resolve, reject) => {
    queue.push({
      call: async () => {
        const { data: resource } = await request(`${host}/${resourceType}`, {
          method: 'POST',
          headers: new Map([['Content-Type', 'application/json']]),
          body,
        });
        return resource;
      },
      resolve,
      reject,
    });

    execute();
  });
};

export const fetchResources = async ({ limit, offset = 0, ids, names }, { request, resourceType }) => {
  let url = `${host}/${resourceType}?offset=${offset}`;

  if (limit) {
    url = `${url}&limit=${limit}`;
  }

  if (ids?.length) {
    url = `${url}&ids=${ids}`;
  }

  if (names?.length) {
    url = `${url}&names=${names.map((name) => encodeURIComponent(name))}`;
  }
  const response = await request(url, {
    method: 'GET',
    headers: new Map([['Content-Type', 'application/json']]),
  });
  return response;
};

export const fetchResourceById = async ({ id }, { request, resourceType }) =>
  request(`${host}/${resourceType}/${id}`, {
    method: 'GET',
    headers: new Map([['Content-Type', 'application/json']]),
  });

export const uploadResource = async (url, file) => {
  return new Promise((resolve, reject) => {
    queue.push({
      call: async () => {
        await fetch(url, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/octet-stream', maxBodyLength: Infinity },
          body: file,
        });
      },
      resolve,
      reject,
    });

    execute();
  });
};
